var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoiok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.035,
    height: 30,
    viewBox: "0 0 30.035 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_744",
    "data-name": "Grupo 744",
    transform: "translate(-487.963 -479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1496",
    "data-name": "Ret\\xE2ngulo 1496",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(497.011 492)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1497",
    "data-name": "Ret\\xE2ngulo 1497",
    width: 11.703,
    height: 2,
    rx: 1,
    transform: "translate(502.308 496)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1498",
    "data-name": "Ret\\xE2ngulo 1498",
    width: 11.703,
    height: 2,
    rx: 1,
    transform: "translate(502.308 500)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1499",
    "data-name": "Ret\\xE2ngulo 1499",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(497.011 488)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1500",
    "data-name": "Ret\\xE2ngulo 1500",
    width: 17,
    height: 2,
    rx: 1,
    transform: "translate(497.011 484)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_99",
    "data-name": "Subtra\\xE7\\xE3o 99",
    d: "M-1127.908-5977h-20.109c-1.736,0-2.441-.081-2.445-2.1h2.962v-.02h20.272v-25.761H-1148.7v11.78h-1.767v-11.78c0-2.039.706-2.12,2.445-2.12h20.109c1.739,0,2.445.081,2.445,2.12v25.761C-1125.463-5977.081-1126.169-5977-1127.908-5977Z",
    transform: "translate(1643.461 6486)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_308",
    "data-name": "Subtra\\xE7\\xE3o 308",
    d: "M6,12a6,6,0,1,1,6-6A6.007,6.007,0,0,1,6,12ZM6,5A1,1,0,0,0,5,6V9A1,1,0,0,0,7,9V6A1,1,0,0,0,6,5ZM6,2A1,1,0,1,0,7,3,1,1,0,0,0,6,2Z",
    transform: "translate(487.963 494)",
    fill: "#f8f9fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoiok);
export default __webpack_public_path__ + "static/media/info iok.85f514d6f6c957ae108378443f301b90.svg";
export { ForwardRef as ReactComponent };